import { BrowserRouter as Router } from "react-router";
import AppRoutes from "./routes/app.route";
import { useEffect } from "react";
import { appTheme } from "./utils/constants";

function App() {
  useEffect(() => {
    if (!localStorage.getItem(appTheme)) {
      localStorage.setItem(appTheme, "dark");
    }
  }, []);
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
